import React from 'react'

const Publication = (props) => {
  const { publication, history, publicationManagementMode } = props


  function getManagedPublicationClassName() {
    const pubClassName = "publication managed-pub"

    if (publication.citation.length && publication.therapeutic_areas.length && !isNaN(publication.year)) {
      if (publication.is_approved) {
        return pubClassName + " pub-green"
      } else {
        return pubClassName + " pub-yellow"
      }
    } else {
      return pubClassName + " pub-red"
    }
  }

  function renderCitationTitle() {
    return publication.citation.length && publication.citation.length > 100 ?
      publication.citation.slice(0, 100) + "..."
      :
      publication.citation
  }

  console.log(publication)

  return (
    <tr
      className={publicationManagementMode ? getManagedPublicationClassName() : "publication"}
      onClick={() => history.push(`/publications/${publication.id}`)}
    >
      <td dangerouslySetInnerHTML={{__html: renderCitationTitle()}}></td>
      <td>
        {publication.authors.map(author => `${author.first_name} ${author.last_name}`).join(', ')}
      </td>
      <td>
        {publication.year}
      </td>
      <td>
        {publication.journal_conference}
      </td>
      {publicationManagementMode ?
        <td>
          {publication.show_url_on_website ?
            "Show URL"
            :
            "Don't show"
          }
        </td>
        :
        null
      }
    </tr>
  )
}

export default Publication



// WEBPACK FOOTER //
// ./src/routes/publications/components/Publication.js